import { FilterSchedulerItem } from '../models/item';

export const filtersSortingItem = (
  a: FilterSchedulerItem,
  b: FilterSchedulerItem,
  nameOfSort: string,
  isAsc: boolean
): number => {
  const compareSorting = (
    first: number | string,
    second: number | string
  ): number => {
    return (first < second ? -1 : 1) * (isAsc ? 1 : -1);
  };
  switch (nameOfSort) {
    case 'workOrder':
      return compareSorting(a.transactionNumber, b.transactionNumber);
    case 'itemName':
      return compareSorting(a.assemblyTitle, b.assemblyTitle);
    case 'endDate':
      const aDate = new Date(a.endDate);
      const bDate = new Date(b.endDate);
      return compareSorting(aDate.getTime(), bDate.getTime());
    case 'quantityAsked':
      return compareSorting(a.quantityRequired, b.quantityRequired);
    case 'quantityProduced':
      return compareSorting(a.quantityBuilt, b.quantityBuilt);
    default:
      return 0;
  }
};
